// Central asset + content data for Banman's Painting
export const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/wxajor2x_IMG_3853.jpeg";

export const PHOTOS = {
  closet: "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/ul9alo49_IMG_0064.webp",
  bedroom: "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/rjwjib3l_IMG_0065.webp",
  accent: "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/tjj8woyj_IMG_0066.webp",
  living: "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/beyp0fpn_IMG_0067.webp",
};

export const EXTERIOR_PHOTOS = [
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/bf0v1r8x_IMG_0070.webp",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/96tmqk2h_52b84254-e28c-4a7a-b9fc-9cca94f812fb.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/ypc7lt3z_IMG_0072.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/c5qhwmeg_c682d2c1-ea3c-489b-bda9-6c6f4a3ccdfa.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/5w9tmuuy_IMG_0069.webp",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/42q9j5ex_IMG_0071.webp",
];

export const INTERIOR_PHOTOS = [
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/llq4bmvi_a2f3f48d-1bc1-45e9-a6a7-361eead4b8e3.webp",
  "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/rjwjib3l_IMG_0065.webp",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/05annqin_b23c6d99-82be-45f0-887e-0b7bf6543234.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/9lcj7agc_164c970b-7201-4f57-aab9-21ba8729849f.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/b59zkub1_2f35339a-6466-41a4-a5ca-ef6f2c03d429.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/ttx68ign_2a700b34-ade6-45d4-8da8-54ac00f43cfb.jpeg",
  "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/beyp0fpn_IMG_0067.webp",
  "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/tjj8woyj_IMG_0066.webp",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/agecw5g6_61ec85ea-7c71-4e9e-93c9-2242cc84b880.webp",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/89weoafm_752857eb-20ef-41e6-a9f6-c8608c1baa16.jpeg",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/bu9cmmy6_b462028c-476a-4018-95d6-9596c7ee2e3d.webp",
  "https://customer-assets-v7afamib.emergentagent.net/job_banmans-paint/artifacts/4650dxd2_89f6c7ff-e10f-4b41-9dd9-1ed6ab599a02.jpeg",
  "https://customer-assets-jai6qajn.emergentagent.net/job_ea3dd06f-16a2-4c6f-b4f9-78c4cc4d22cb/artifacts/ul9alo49_IMG_0064.webp",
];

export const CONTACTS = [
  { name: "Raul", phone: "806-310-3226", tel: "8063103226" },
  { name: "Maribel", phone: "806-310-3021", tel: "8063103021" },
];

export const SERVICE_OPTIONS = [
  "Interior Painting",
  "Exterior Painting",
  "Not Sure Yet",
];
